<template>
    <ConfirmDialog />
    <Toast />
	<div class="grid nested-grid">
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">Gorazd: {{ translated('financedSourcetitle') }}</h5>
				</div>												
			</div>
            <DataTable :value="financedSourceRecords" class="p-datatable-sm" removableSort showGridlines dataKey="id" 
            v-model:loading="loading1" responsiveLayout="scroll" :rowHover="true"            
            :paginator="false" :rows="100">
                    <template #header>
                        <div class="flex justify-content-between">
                            <Button :disabled="isReadOnly" :label="translated('virfinancranjanovo')" icon="pi pi-plus" class="p-button" @click="openModalAddFinanced()"  />	
                        </div>
                    </template>        
                    <template #empty>
                        No financed records found.
                    </template>
                    <template #loading>
                        Loading financed data. Please wait.
                    </template>    
                    

                <Column :header="translated('financedNameVir')" field="Name" :sortable="true"></Column>                           
                <Column :header="translated('finacedDescriptionVir')">
                    <template #body="slotProps">
                        <div style="white-space: pre-line; word-break: break-word;">
                            {{ slotProps.data.Description }}
                        </div>
                    </template>                
                </Column>

                <Column :exportable="false" :style="{width:'100px'}">
                    <template #body="slotProps">
                        <Button :disabled="isReadOnly" icon="pi pi-trash" class="p-button-rounded p-button-warning deletebutton" @click="deleteFinanced(slotProps.data)" />
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 editbutton" @click="openModalEditFinanced(slotProps.data)" />											
                    </template>
                </Column>	               
            </DataTable>
        </div>  
    </div>  

    <Dialog v-model:visible="displayModalAddFinanced" :style="{width: '30vw'}" :modal="true" class="globalDialog">
        <template #header>
            <span class="p-dialog-title">{{ popupTitle }}</span>
        </template>	
        <div class="card fluid">       

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('financedNameVir') }}</label>
                <div class="col-12 md:col-8">
                    <InputText type="text" v-model="tmpName" />						
                </div>                        
            </div>	
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('finacedDescriptionVir') }}</label>
                <div class="col-12 md:col-8">                    	
                    <Textarea v-model="tmpDescription" rows="5"  />								
                </div>                        
            </div>		            		
                                                    
        </div>
        <template #footer>
            <Button :label="translated('canclebutton')" icon="pi pi-times" @click="closeModalAddFinanced" class="p-button-text"/>
            <Button :disabled="isReadOnly" :label="translated('savebutton')" icon="pi pi-check" @click="closeAndAddModalAddFinanced" autofocus />
        </template>
    </Dialog>    
</template>

<script>

import {FilterMatchMode,FilterOperator} from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
import Calendar from 'primevue/calendar';

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
    components: { Calendar },
  data() {
    return {
        translated: computed(() => store.getters.getTranslate),
        filters1: null,
        loading1: true,
        displayModalAddFinanced: false,
        popupTitle: '',
        tmpId:'',
        tmpName:'',
        tmpDescription: '',
        financedSourceRecords: null,
    }
  },
  created() {
      this.initFilters1();
  },  
  async mounted() {
    await this.loadRecords();
  },
  methods: {
      
    async loadRecords() {
        this.loading1 = true
        const http = createHttp(true); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinancedSourceRecords");

        if(result.status==200){
            this.financedSourceRecords = result.data
        }

        this.loading1 = false
    },
    getEmptyGuid() {  
        return '00000000-0000-0000-0000-000000000000'
	},
      clearFilter1() {
          this.initFilters1();
      },
      initFilters1() {
          this.filters1 = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          }
      },
      openModalAddFinanced() {
          this.popupTitle = this.translated('addingnewfinanced'); 
          this.tmpId = this.getEmptyGuid()
          this.tmpName = ''
          this.tmpDescription = ''
          this.tmpFinancedFrom = null
          this.tmpFinancedTill = null
          this.displayModalAddFinanced = true
      },
      openModalEditFinanced(FinancedObj) {
          this.popupTitle = this.translated('virifinanciranjanovotitle'); 
          this.tmpId = FinancedObj.Id
          this.tmpName = FinancedObj.Name
          this.tmpDescription = FinancedObj.Description
          this.displayModalAddFinanced = true
      },
      closeModalAddFinanced() {
          this.displayModalAddFinanced = false
      },
      async closeAndAddModalAddFinanced() {
            const http = createHttp(true); 
            try {
                /*
                console.log('zacnem klic ADD');
                console.log(http);
                */
                const financedObj = {
                    Id: this.tmpId,
                    Name: this.tmpName,
                    Description: this.tmpDescription
                }

                console.log(this.tmpFinancedFrom, this.tmpFinancedTill);
                console.log('parameter:');
                console.log(financedObj);
                
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/InsertUpdateFinancedSource", financedObj );
                //console.log('response na ADD/UPDATE')
                //console.log(response)

                if(response.status==200) {
                    // paymentObj.Id = response.data.Id
                    // this.paymenttypes.push(paymentObj)
                    /*
                    console.log('VSE JE OK!!!')
                    console.log('payment types:');
                    console.log(this.paymenttypes);
                    */
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Record saved!', life: 3000});

                    await this.loadRecords();
                } else {
                    console.log('ERROR!!!')
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'ERROR', life: 3000});
                }

                //console.log(response)
                
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                console.log(error);
                this.$toast.add({severity:'success', summary:'Confirmed', detail:'ERROR', life: 3000});
            }

            this.displayModalAddFinanced = false
            
      },      
      async deleteFinanced(FinancedObj) {
        this.$confirm.require({
            message: this.translated('virifinanciranjabrisanje'), //'Are you sure you want DELETE Financed record?',
            header: this.translated('deletetitle'), // 'DELETE?',
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger',
            accept: async () => {
                //callback to execute when user confirms the action

                const http = createHttp(true); 
                try {
                    //console.log('zacnem klic delete');
                    //console.log(http);
                    const response = await http.delete(process.env.VUE_APP_API_FOLDER + "/DeleteFinancedSourceRecord?id=" + FinancedObj.Id );
                    //console.log('response na DELETE')
                    //console.log(response)

                    if(response.status==200) {
                        /*
                        console.log('VSE JE OK!!!')
                        console.log('payment types:');
                        console.log(FinancedObj.Id);
                        console.log(this.paymenttypes);
                        */
                        // izbrišem še iz kolekcije, da se odstrani iz app
                        // const arr = this.paymenttypes.filter(function(item) {                            
                        //     return item.Id !== FinancedObj.Id
                        // })

                        // this.paymenttypes = arr       
                        await this.loadRecords();                     
                    } else {
                        console.log('ERROR!!!')
                    }

                    //console.log(response)
                } catch (error) {
                    //console.log('ERROR TRY CATCHE!');
                    console.log(error);
                }
                //console.log(FinancedObj);
                this.$toast.add({severity:'success', summary:'Confirmed', detail:'Record deleted', life: 3000});
                //console.log('klical accept');
            },
            reject: () => {
                //console.log('klical reject');
                //callback to execute when user rejects the action
            }
        });
      }
  },
  computed: {
    isReadOnly() {
        return this.$store.getters.isInRole("ReadOnly");
    }
  }  
}
</script>

<style scoped>
 button.deletebutton, button.editbutton {
    position: relative;
    float: right;
}
</style>